import { render, staticRenderFns } from "./EmptyPage.vue?vue&type=template&id=58df4835&scoped=true&"
import script from "./EmptyPage.vue?vue&type=script&lang=js&"
export * from "./EmptyPage.vue?vue&type=script&lang=js&"
import style0 from "./EmptyPage.vue?vue&type=style&index=0&lang=less&"
import style1 from "./EmptyPage.vue?vue&type=style&index=1&id=58df4835&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58df4835",
  null
  
)

export default component.exports